/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';

import { removeCookie, setCookie } from '@shared/utils';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  hideOptin = true;

  constructor(
    public http: HttpClient,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkAppLocation();
    const product = this.route.snapshot.queryParamMap.get('product');
    if (product) {
      setCookie('product', product, 7);
    } else {
      removeCookie('product');
    }
  }

  checkAppLocation(): void {
    const { host } = window.location;
    const hostArray = host.split('.');
    if (hostArray[0].includes('localhost')) {
      // default domain is CH so we don't have to check domain country code.
      this.hideOptin = true;
    } else {
      // show newsletter & update checkbox false
      this.hideOptin = hostArray[hostArray.length - 1].includes('ch');
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
